import React, { useState } from 'react'
import { Table } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import { newID } from 'helpers/utils'
import _uniqueId from 'lodash/uniqueId'

interface Props {
  columns: any
  datas: any[]
  isLoading?: boolean
  paginationContent?: any
  rowClassName?: any
  scrollX?: number
  size?: SizeType
  onRow?: any
  offsetHeader?: number
  bordered?: boolean
  style?: any
  expandable?: any
  tableName?: string
  rowKey?: string
  onSort?: (field: string, order: string) => void
  className?: string
}
const TableListPage = (props: Props): any => {
  const {
    columns,
    datas,
    isLoading = false,
    paginationContent,
    rowClassName,
    scrollX = 1000,
    size = 'middle',
    onRow = () => {},
    offsetHeader = -20,
    bordered = false,
    style,
    expandable,
    tableName = 'table',
    rowKey = 'id',
    className = '',
    onSort = () => {},
  } = props

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    onSort(
      sorter?.order ? sorter?.field : '',
      sorter?.order ? (sorter?.order === 'descend' ? 'desc' : 'asc') : '',
    )
  }

  return (
    <ContentWrapper className={className}>
      <TableStyled
        size={size}
        columns={columns}
        dataSource={datas}
        scroll={{ x: scrollX }}
        pagination={false}
        sticky={{ offsetHeader: offsetHeader }}
        loading={isLoading}
        rowClassName={rowClassName}
        onRow={onRow}
        rowKey={(record: any) => (record && record[rowKey]) || ''}
        bordered={bordered}
        style={style}
        expandable={expandable}
        onChange={handleTableChange}
        showSorterTooltip={false}
      />
      {paginationContent && <PaginationWrapper>{paginationContent}</PaginationWrapper>}
    </ContentWrapper>
  )
}

const ContentWrapper = styled.div`
  margin: 10px 0;
  padding-top: 1px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border-radius: 10px;
  td {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  }

  .ant-table-thead > tr > th {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  }

  .row-disabled {
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.disable};
    .ant-image {
      opacity: 0.5;
    }
    .ant-image-mask-info {
      opacity: 0.1;
    }
  }
  .row-new {
    background-color: #52c41a29;
    transition: all 3s ease-out;
  }

  .overstock {
    background-color: #52c41a29;
  }
`

const PaginationWrapper = styled.div`
  padding: 20px 5px;
`

const TableStyled = styled(Table)``

export default TableListPage
